import React from "react"
import "./rankMember.css"
import * as Moment from "moment"
import styled from "styled-components"

const RoleBlock = styled.div`
  margin-left: 5px;
  font-size: 0.75em;
`

const Title = styled.div`
  font-size: 1.2em;
  /* font-weight: bold; */
  color: #910;
`

const RankMember = props => {
  const currentRankImage =
    props.memberRanks[0] && props.memberRanks[0].level
      ? "/" + props.memberRanks[0].level.LevelImage
      : null

  const currentRankShort =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <div>
        <img className="rank" src={currentRankImage} />
      </div>
    ) : null

  const currentRank =
    props.memberRanks[0] && props.memberRanks[0].level ? (
      <div>
        {props.member.Title ? <span>{props.member.Title}, </span> : null}{" "}
        {props.memberRanks[0].level.LevelTitle},{" "}
        <span className="experience">{Moment(props.memberRanks[0].RankDate).fromNow()}</span>
      </div>
    ) : null

  const memberRole = props.member.Role ? <div>{props.member.Role}</div> : null
  const memberExtraRole = props.member.ExtraRole ? <div>{props.member.ExtraRole}</div> : null

  return (
    <div className="rankMember" onClick={() => props.toggleMember(props.member.ID)}>
      <div className="bottom">
        <div className="member-image-wrapper">
          <img className="image" src={props.member.ImageUrl} />
        </div>

        <div>{currentRankShort}</div>
        <div lassName="member-info">
          <RoleBlock>
            <Title>
              {props.member.FirstName}
              &nbsp;{props.member.LastName},{" "}
              {Moment().diff(Moment(props.member.Birthdate), "years", false)} år
            </Title>
            <div>{currentRank}</div>
            <div>
              {memberRole}
              {props.member.TeamName}
            </div>
          </RoleBlock>
        </div>
      </div>
    </div>
  )
}

export default RankMember
